import React from "react";
import { AttributeSetController } from "./AttributeSetController";
import { AttributeSetViewModel } from "./AttributeSetViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class AttributeSetProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new AttributeSetViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <AttributeSetController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AttributeSet/AttributeSetProvider.js